export const toggleBudgets = () => {
  const budgetFormItem = $("#GroupMessageBudget");
  const budgetForms = $('.MailMessageBudget');
  const checkedSelections = $("input[type='checkbox']:checked.mail-input-inquiries");

  // バックエンド側で定義している予算回答が必須の項目リストと比較
  const matchedSelections = checkedSelections.filter(function (_, ele) {
    return gon.budget_required_selections.indexOf(ele.value) != -1;
  }).get();

  if (matchedSelections.length > 0) {
    budgetFormItem.show('slow');
    budgetForms.prop('disabled', false);
  } else {
    budgetFormItem.hide();
    budgetForms.prop('disabled', true);
  }
}
